import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { APP_PRIZE_COINS, APP_ROUTES } from "../../constants";
import "./style.scss";
import { useCurrentUser } from "../../layouts/UserContext";
import {
  BigGreenButton,
  BottomNav,
  CountdownBanner,
  FinalBanner,
  ProfileCard,
  TaskCard,
} from "../../components";
import {
  PopupTaskQR,
  PopupTaskEmoji,
  PopupTaskInvite,
  PopupTaskTrailer,
  PopupTaskResult,
} from "./components";
import taskInvite from "../../../images/task-invite.jpg";
import taskTv3Subscribe from "../../../images/task-tv3-subscribe.png";
import taskNameEmoji from "../../../images/task-name-emoji.jpg";
import taskTrailerCode from "../../../images/task-trailer-code.jpg";
import RequestUtil from "../../utils/RequestUtil";
import { CommonUtil } from "../../utils/CommonUtil";
import axios from "axios";

const POPUP_NAME = {
  TASK_EMOJI: "task_emoji",
  TASK_INVITE: "task_invite",
  TASK_QR: "task_qr",
  TASK_RESULT: "task_result",
  TASK_STORY: "task_story",
  TASK_TRAILER: "task_trailer",
};

const gameOver = document.getElementById("root").dataset.gameOver === "yes";

export const HomePage = ({ startParamValue }) => {
  console.log({ gameOver });
  const { user, setUser } = useCurrentUser();
  const [popupName, setPopupName] = useState(null);
  const [popupResult, setPopupResult] = useState(null);
  const [startParam, setStartParam] = useState(startParamValue || null);
  const [showCountdown, setShowCountdown] = useState(false);
  const location = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const shouldReload = params.get("shouldReload");

    if (shouldReload === "true") {
      // Удаляем параметр
      params.delete("shouldReload");
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${params.toString()}`
      );

      // Перезагружаем страницу
      window.location.reload();
    }
  }, []);

  // useEffect(() => {
  //   console.log("ЗАГРУЗКА home");
  //   // Проверяем наличие ключа firstVisit в sessionStorage
  //   const firstVisit = localStorage.getItem("isFirstVisit");

  //   if (firstVisit) {
  //     console.log("Первое посещение");
  //     // Если ключ есть, перезагружаем страницу и очищаем sessionStorage
  //     localStorage.removeItem("isFirstVisit");
  //     window.location.reload();
  //   }

  //   return () => {
  //     localStorage.removeItem("isFirstVisit");
  //   };
  // }, []);

  // const checkEmoji = () => {
  //   console.log("[Ladybug.Emoji] > check");
  //   RequestUtil.post("emoji", {
  //     hash: user.authToken,
  //   })
  //     .then((response) => {
  //       user.coins = response.coins;
  //       user.tasks.push("emoji");
  //       setUser(user);
  //       console.log(
  //         "[Ladybug.Emoji] > win: " + response?.reason + " " + response?.score
  //       );

  //       setPopupResult({
  //         success: true,
  //         title: "Измени свое имя",
  //         text: `+<strong><span>${response.score}&nbsp;баллов</span> уже на твоём счёте!</strong>`,
  //       });
  //       setPopupName(POPUP_NAME.TASK_RESULT);
  //     })
  //     .catch((errors) => {
  //       console.log("[Ladybug.Emoji] > fail");
  //       setPopupResult({
  //         success: false,
  //         title: "Измени свое имя",
  //         text: `Хмм... Не получилось найти 🐞<br/> в твоем имени профиля`,
  //       });
  //       setPopupName(POPUP_NAME.TASK_RESULT);
  //     });
  // };

  const checkTrailer = (code) => {
    console.log("[Ladybug.Trailer] > check");
    axios
      .post("https://lovi-kwami.tv3.ru/api/ladybug-game/trailer", {
        hash: user.authToken,
        code,
      })
      .then((response) => {
        const currentTime = new Date();
        const cutoffTime = new Date("2024-12-21T19:00:00Z");
        const isCompetitionFinished = currentTime >= cutoffTime;

        if (isCompetitionFinished && response?.data) {
          response.data.coins = user.coins;
          response.data.score = 0;
        } // TO DO удалить когда насчнется новый конкурс

        console.log("trailer res", response);
        user.coins = response.data.coins;
        user.tasks.push("trailer");
        setUser(user);
        console.log(
          "[Ladybug.Trailer] > win: " +
            response?.data.reason +
            " " +
            response?.data.score
        );

        setPopupResult({
          success: true,
          title: "Видео",
          text: `+<strong><span>${response.data.score}&nbsp;баллов</span> уже на твоём счёте!</strong>`,
        });
        setPopupName(POPUP_NAME.TASK_RESULT);
      })
      .catch((errors) => {
        console.log("[Ladybug.Trailer] > fail");
        setPopupResult({
          success: false,
          title: "Видео",
          text: `Хмм... Это неверный код.<br/> Посмотри ещё раз очень внимательно.`,
        });
        setPopupName(POPUP_NAME.TASK_RESULT);
      });
  };

  const checkSubscription = () => {
    if (false === user?.tasks?.includes("subscribe")) {
      console.log("[Ladybug.Subscription] > check");
      axios
        .post("https://lovi-kwami.tv3.ru/api/ladybug-game/subscription", {
          hash: user.authToken,
        })
        .then((response) => {
          if (!response) {
            throw Error();
          }
          const currentTime = new Date();
          const cutoffTime = new Date("2024-12-21T19:00:00Z");
          const isCompetitionFinished = currentTime >= cutoffTime;

          if (isCompetitionFinished) {
            response.data.coins = user.coins;
            response.data.score = 0;
          }// TO DO удалить когда насчнется новый конкурс

          console.log("subscribe res", response);
          user.coins = response.data.coins;
          user.tasks.push("subscribe");
          setUser(user);
          console.log(
            "[Ladybug.Subscription] > win: " +
              response?.data.reason +
              " " +
              response?.data.score
          );

          setPopupResult({
            success: true,
            title: "Подписаться на канал",
            text: `+<strong><span>${response.data.score}&nbsp;баллов</span> уже на твоём счёте!</strong>`,
          });
          setPopupName(POPUP_NAME.TASK_RESULT);
        })
        .catch(() => {
          console.log("[Ladybug.Subscription] > fail");
          setPopupResult({
            success: false,
            title: "Подписаться на канал",
            text: `Скорее подпишись<br/> на наш канал <a href="https://t.me/tv3russia">@tv3russia</a>!`,
          });
          setPopupName(POPUP_NAME.TASK_RESULT);
        });
    }
  };

  useEffect(() => {
    console.log("[Ladybug.Home] > ready");
    CommonUtil().ymReachGoal("ladybug_game_view_home");
  }, []);

  useEffect(() => {
    const targetDate = new Date("2024-12-21T19:00:00Z");
    const currentDate = new Date();
    setShowCountdown(currentDate < targetDate);
}, []);

  // useEffect(() => {
  //   if (startParam) {
  //     console.log("[Ladybug.StartParam] > " + startParam);
  //     axios.post('https://lovi-kwami.tv3.ru/api/ladybug-game/invite', {
  //       hash: user.authToken,
  //       // type: startParam.substring(0, 2),
  //       invitedBy: startParam,
  //     })
  //       .then((response) => {
  //         // console.log(
  //         //   "[Ladybug.StartParam] > win: " +
  //         //     response?.reason +
  //         //     " " +
  //         //     response?.score
  //         // );
  //         // if ("qr" === response?.reason) {
  //         //   setPopupResult({
  //         //     success: true,
  //         //     title: "QR-код отсканирован!",
  //         //     text: `+<strong><span>${response.score}&nbsp;баллов</span> уже на твоём счёте!</strong>`,
  //         //   });
  //         //   setPopupName(POPUP_NAME.TASK_RESULT);
  //         // }
  //       })
  //       .catch(() => {
  //         console.log("[Ladybug.Invite] > fail");
  //       });
  //   }
  // }, [startParam]);

  console.log({ finalBannerVisible: gameOver });

  return (
    <div className="app-home app-hide-scroll">
      {showCountdown ? <CountdownBanner /> : <FinalBanner />}

      {/* <CountdownBanner
        onClick={() => {
          CommonUtil().ymReachGoal("ladybug_game_click_banner_qrcode");
          setPopupName(POPUP_NAME.TASK_QR);
        }}
      /> */}

      <ProfileCard
        photo={user.photo || null}
        coins={user.coins}
        subscribed={user.chatMember}
      />
      <BigGreenButton
        onClick={() => {
          CommonUtil().ymReachGoal("ladybug_game_click_start_game");
          navigate(APP_ROUTES.GAME);
        }}
      >
        Играть
      </BigGreenButton>
      <div className="app-home--tasks">
        <h2>Задания</h2>
        <TaskCard
          image={taskInvite}
          title="Пригласить друга"
          coins={APP_PRIZE_COINS.INVITE}
          completed={user?.tasks?.includes("invite")}
          onClick={() => {
            if (false === user?.tasks?.includes("invite")) {
              CommonUtil().ymReachGoal("ladybug_game_click_invite_friends");
              setPopupName(POPUP_NAME.TASK_INVITE);
            }
          }}
        />
        {/*<TaskCard*/}
        {/*    image={taskPubStory}*/}
        {/*    title="Опубликовать историю"*/}
        {/*    coins={APP_PRIZE_COINS.STORY}*/}
        {/*    completed={user?.tasks?.includes('story')}*/}
        {/*    onClick={() => {*/}
        {/*      if (false === user?.tasks?.includes('story')) {*/}
        {/*        CommonUtil().ymReachGoal('ladybug_game_stories_view');*/}
        {/*        setPopupName(POPUP_NAME.TASK_STORY);*/}
        {/*      }*/}
        {/*    }}*/}
        {/*/>*/}
        <TaskCard
          image={taskTv3Subscribe}
          title="Подписаться на канал ТВ-3"
          coins={APP_PRIZE_COINS.SUBSCRIBE}
          completed={user?.tasks?.includes("subscribe")}
          onClick={() => {
            if (false === user?.tasks?.includes("subscribe")) {
              checkSubscription();
            }
          }}
        />
        {/* <TaskCard
                image={taskNameEmoji}
                title="Изменить свое имя в Телеграм"
                coins={APP_PRIZE_COINS.EMOJI}
                completed={user?.tasks?.includes('emoji')}
                onClick={() => {
                    if (false === user?.tasks?.includes('emoji')) {
                        setPopupName(POPUP_NAME.TASK_EMOJI);
                    }
                }}
            /> */}
        <TaskCard
          image={taskTrailerCode}
          title="Найти и ввести код из видео"
          coins={APP_PRIZE_COINS.TRAILER}
          completed={user?.tasks?.includes("trailer")}
          onClick={() => {
            if (false === user?.tasks?.includes("trailer")) {
              CommonUtil().ymReachGoal("ladybug_game_trailer_view");
              setPopupName(POPUP_NAME.TASK_TRAILER);
            }
          }}
        />
      </div>
      <BottomNav />

      {/* Emoji */}
      {/* {POPUP_NAME.TASK_EMOJI === popupName && (
        <PopupTaskEmoji
          user={user}
          onCheck={() => checkEmoji()}
          onClose={() => setPopupName(null)}
        />
      )} */}

      {/* Invite */}
      {POPUP_NAME.TASK_INVITE === popupName && (
        <PopupTaskInvite onClose={() => setPopupName(null)} />
      )}

      {/* QR */}
      {/* {POPUP_NAME.TASK_QR === popupName && <PopupTaskQR
            onQrRead={value => setStartParam(value)}
            onClose={() => setPopupName(null)}
        />} */}

      {/* Result */}
      {POPUP_NAME.TASK_RESULT === popupName && (
        <PopupTaskResult
          success={popupResult.success}
          title={popupResult.title}
          text={popupResult.text}
          onClose={() => {
            setPopupName(null);
            setPopupResult(null);
          }}
        />
      )}

      {/* Story */}
      {/*{POPUP_NAME.TASK_STORY === popupName && <PopupTaskStory*/}
      {/*    onClose={() => setPopupName(null)}*/}
      {/*/>}*/}

      {/* Trailer */}
      {POPUP_NAME.TASK_TRAILER === popupName && (
        <PopupTaskTrailer
          onCheck={(value) => checkTrailer(value)}
          onClose={() => setPopupName(null)}
        />
      )}
    </div>
  );
};
